import React from 'react';

function EmptyState({ icon = 'fa-info-circle', title, message, actionText, onAction }) {
  return (
    <div className="text-center py-5">
      <i className={`fas ${icon} fa-3x text-muted mb-3`}></i>
      <h5 className="font-weight-bold text-gray-800">{title}</h5>
      <p className="text-muted mb-4">{message}</p>
      {actionText && onAction && (
        <button className="btn btn-primary" onClick={onAction}>
          {actionText}
        </button>
      )}
    </div>
  );
}

export default EmptyState;